export const environment = {
  production: false,
  DEFAULT_LANGUAGE: 'en',
  LANGUAGES: ['en', 'fr'],
  ENVIRONMENT: 'UAT',
  GOOGLE_API_KEY: 'AIzaSyAjRI4gCcni8TnNCkOco6HvOOw-KwgV9jk',

  okta: {
    clientId: '0oad0l6rjd6xJWgCk0x7',
    issuer: 'https://caluwin.oktapreview.com/oauth2/default',
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },

  caluwin_api: {
    base_url: 'https://dev-api.calculations.caluwin.swisspacer.com',
    config_base_url: 'https://dev-api.configurations.caluwin.swisspacer.com',
    endpoints: {
      air_simulation_comprehensive: '/api/AirSimulation/calculate',
      comfort_calculator: '/api/Comfort/condensation-mould-risk',
      energy_rating_uk: '/api/EnergyRating/window-energy-rating/uk',
      energy_rating_fr: '/api/EnergyRating/window-energy-rating/fr',
      energy_rating_ch: '/api/EnergyRating/window-energy-rating/ch',
      energy_rating_dk: '/api/EnergyRating/window-energy-rating/dk',
      energy_rating_phe: '/api/EnergyRating/window-energy-rating/phe',
      window_config: '/api/window/config',
      thermal_uw: '/api/Thermal/uw',
      thermal_psi: '/api/Thermal/psi',
      md_frames_manufacturers: '/api/Frames/manufacturers',
      md_frames: '/api/Frames',
      md_glasses: '/api/Glasses',
      md_manufacturer: '/api/Manufacturer',
      md_spacer: '/api/Spacer',
      deactivateUser: 'https://caluwin.oktapreview.com/api/v1/users/{userId}/lifecycle/deactivate',
      deleteUser: '/api/configuration/{userId}',
      config_list: '/api/Configuration/ConfigList/{userId}',
      saveConfiguration:'/api/Configuration/save',
      generatePdf: '/api/Pdf',
      deleteConfiguration: '/api/Configuration/{id}'
    },
    timeout: 25000 // 25 seconds
  },
};